import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { formatNumberToFixedPdf as formatNumberToFixed } from 'utils';
import { DEFAULT_GLASS_SIZE_TOTALS } from 'domain/glass';
import PdfGlassConfigTableRowCell from './PdfGlassConfigTableRowCell';

import styles from '../styles';

const PdfGlassConfigTableRow = ({
	tableRow,
	displayPosition,
	totalValues,
	oversizedGlassFields,
	showPrice,
	priceVolumeCat,
}) => {
	const { t } = useTranslation('configurationTableHeading');
	const notes = tableRow.row.find(cellItem => cellItem.name === 'notes') || { value: '-' };
	const total = totalValues || { m2Pc: '-', ...DEFAULT_GLASS_SIZE_TOTALS };
	const p = showPrice && total.prices?.[priceVolumeCat];
	const displayPrice = showPrice ? formatNumberToFixed(p || '-', 2, t('i18n:numberFormat')) : '-';

	return (
		<>
			<View style={styles.glassConfigTableRow}>
				{displayPosition ? (
					<View
						style={{ ...styles.glassConfigTableCell, ...styles.glassConfigTableCellFirstChild }}
					>
						<Text>{displayPosition}</Text>
					</View>
				) : null}
				{tableRow.row && tableRow.row.length ? (
					<>
						{tableRow.row.map((cellItem, index) => {
							if (cellItem.name === 'notes') return null;
							let cellData = {
								...cellItem,
								value:
									cellItem.name === 'cantonalInsurance'
										? cellItem.value
										: formatNumberToFixed(cellItem.value, 0, t('i18n:numberFormat')),
							};
							const isLengthOrWidthField = cellItem.name === 'length' || cellItem.name === 'width';
							const isIncomplete =
								(isLengthOrWidthField || cellItem.name === 'quantity') && cellItem.value === '';
							const isOversized =
								isLengthOrWidthField && !isIncomplete && oversizedGlassFields?.id === tableRow.id;
							if (isOversized) {
								cellData.value += ' (!)'; // ⚠
							}
							return (
								<PdfGlassConfigTableRowCell
									key={index}
									cellData={cellData}
									isIncomplete={isIncomplete || isOversized}
								/>
							);
						})}
						<PdfGlassConfigTableRowCell
							cellData={{ value: formatNumberToFixed(total.m2Pc, 2, t('i18n:numberFormat')) }}
						/>
						<PdfGlassConfigTableRowCell
							cellData={{ value: formatNumberToFixed(total.m2, 2, t('i18n:numberFormat')) }}
						/>
						<PdfGlassConfigTableRowCell
							cellData={{ value: formatNumberToFixed(total.kg, 0, t('i18n:numberFormat')) }}
							isLastCell={!showPrice}
						/>
						{showPrice && (
							<PdfGlassConfigTableRowCell cellData={{ value: displayPrice }} isLastCell />
						)}
					</>
				) : null}
			</View>
			<View style={{ ...styles.glassConfigTableRow, ...styles.glassConfigTableRow2 }}>
				<Text
					style={{
						...styles.glassConfigTableCell,
						...styles.glassConfigTableCellFirstChild,
						...styles.glassConfigTableCellTitle,
					}}
				>
					{t('notes')}
				</Text>
				<PdfGlassConfigTableRowCell cellData={notes} isLastCell isNotes />
			</View>
		</>
	);
};

export default PdfGlassConfigTableRow;
